const l = {
  name: "Rules",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.00015 8.41424L1.58594 5.00003L3.00015 3.58582L5.00015 5.58582L9.00015 1.58582L10.4144 3.00003L5.00015 8.41424Z" fill="currentColor"/>
<path d="M12 4.00003H22V6.00003H12V4.00003Z" fill="currentColor"/>
<path d="M12 11H22V13H12V11Z" fill="currentColor"/>
<path d="M22 19V21H12V19H22Z" fill="currentColor"/>
<path d="M5.00015 15.4142L1.58594 12L3.00015 10.5858L5.00015 12.5858L9.00015 8.58582L10.4144 10L5.00015 15.4142Z" fill="currentColor"/>
<path d="M5.00015 22.4142L1.58594 19L3.00015 17.5858L5.00015 19.5858L9.00015 15.5858L10.4144 17L5.00015 22.4142Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as Rules
};
